const productItemsTypes ={
    PRODUCT_ITEMS_GET: 'PRODUCT_ITEMS_GET',
    PRODUCT_ITEMS_SUCCESS: 'PRODUCT_ITEMS_SUCCESS',
    PRODUCT_ITEMS_FAIL: 'PRODUCT_ITEMS_FAIL',
    ITEM_DETAILS_GET: 'ITEM_DETAILS_GET',
    ITEM_DETAILS_SUCCESS: 'ITEM_DETAILS_SUCCESS',
    ITEM_DETAILS_ERROR: 'ITEM_DETAILS_ERROR',
}
export default productItemsTypes;